'use client';

import { Trans } from '@lingui/macro';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { Button } from '@prismo-io/design-system';
import { useRouter } from '@prismo-io/router';
import { usePathname } from 'next/navigation';
import type { FC } from 'react';
import { useSWRConfig } from 'swr';
import { useDeleteFormation } from '../../../hooks/use-delete-formation';
import { SkeletonItems } from '../skeleton-item';
import { useFormationsSidebar } from './use-formations-sidebar';

export const SidebarFormationList: FC = () => {
  const { data: formations = [], isLoading } = useFormationsSidebar();

  const router = useRouter();
  const pathname = usePathname();
  const { mutate } = useSWRConfig();

  const onClick = (id: string | null) => {
    if (!id) {
      router.replace(pathname);
      return;
    }

    const query = `?id=${id}`;

    router.replace(pathname + query);
  };

  const { trigger: deleteFormation } = useDeleteFormation();

  const onDeleteItem = (id: string) => {
    deleteFormation(id, {
      onSuccess: async () => {
        router.replace(pathname);
        mutate('formation-quark-sidebar');
      },
    });
  };

  return (
    <>
      <Stack
        component="header"
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        gap={2}
        flexWrap="wrap"
        padding={2}
      >
        <Typography variant="h1">
          <Trans>Mes formations ({formations.length})</Trans>
        </Typography>
        <Button variant="outlined" onClick={() => onClick(null)}>
          <Trans>+ Ajouter</Trans>
        </Button>
      </Stack>
      <List>
        {/* <ListItem disablePadding>
          <ListItemButton onClick={() => onClick(null)}>
            <ListItemText primary={t`Ajouter une formation`} />
          </ListItemButton>
        </ListItem> */}
        {isLoading && <SkeletonItems />}
        {formations.map((form) => {
          return (
            <ListItem
              key={form.id}
              disablePadding
              sx={{ marginY: '0.25rem' }}
              secondaryAction={
                <IconButton
                  edge="end"
                  aria-label="delete"
                  onClick={() => onDeleteItem(form.id)}
                >
                  <DeleteOutline />
                </IconButton>
              }
            >
              <ListItemButton onClick={() => onClick(form.id)}>
                <ListItemText
                  primary={form.name}
                  sx={{
                    '& .MuiListItemText-primary': {
                      fontWeight: 700,
                      textDecoration: 'underline',
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </>
  );
};
